module.exports = __webpack_public_path__ + "img/6.c7cef5ca.jpg";